import React, { useEffect } from 'react';
import Select, { components } from "react-select";

const Menu = (props) => {
    return (
        <>
            <components.Menu {...props}>
                <div className="dropdowninnersection">
                    <div className="dropdownlabelbtn">
                        <div className="dropheaderlabel">{props.selectProps.menuHeader}</div>
                        <button className="dropheaderbtn" onClick={props.selectProps.oncloseMenu}>
                            <img src={require('../Public/images/dropcloseicon.png')} />
                        </button>
                    </div>
                    <div>{props.children}</div>
                </div>
            </components.Menu>
        </>
    );
};

const AutosuggestComponent = (props) => {

    const componentDidMount = () => {
    }
    const oncloseMenu = () => {
        selectRef.select.blur()
    }
    let selectRef = null
    const { closeButton, menuHeader, openMenu, handleFocus } = props
    return (

        <div>
            {closeButton == false ?
                <Select
                    value={props.selectedValue}
                    isClearable={props.isClearable}
                    isSearchable={props.isSearchable}
                    options={props.options}
                    name={props.name}
                    isMulti={props.isMulti}
                    onChange={props.handleOnChange}
                    onInputChange={props.handleOnInputChange}
                    onBlur={props.handleOnBlurChange}
                    placeholder={props.placeholder}
                    isDisabled={props.isDisabled}
                    className="basic-select"
                    id={props.id}
                    menuPosition={props.menuPosition}
                    maxMenuHeight={props.maxMenuHeight}
                    classNamePrefix='dropdown_menu_box'
                    onFocus={handleFocus}
                /> :
                <Select
                    value={props.selectedValue}
                    isClearable={props.isClearable}
                    isSearchable={props.isSearchable}
                    options={props.options}
                    name={props.name}
                    isMulti={props.isMulti}
                    onChange={props.handleOnChange}
                    onInputChange={props.handleOnInputChange}
                    onBlur={props.handleOnBlurChange}
                    placeholder={props.placeholder}
                    isDisabled={props.isDisabled}
                    className="basic-select"
                    components={{
                        Menu
                    }}
                    menuHeader={menuHeader}
                    oncloseMenu={oncloseMenu}
                    ref={(scope) => { selectRef = scope }}
                    classNamePrefix='dropdown_menu_box'
                />}

        </div>
    );

}
AutosuggestComponent.defaultProps = {
    isClearable: false,
    closeButton: false,
    menuHeader: "",
    openMenu: true,
    isSearchable: false,
    id: "",
    menuPosition: "",
    maxMenuHeight: 300
}
export default AutosuggestComponent;
